// extracted by mini-css-extract-plugin
export var asideList = "courses-movie-group-module--aside-list--OSa9d";
export var emptyScreen = "courses-movie-group-module--empty-screen--JBVNx";
export var fakeWrapperIconLock = "courses-movie-group-module--fake-wrapper-icon-lock--OP6rj";
export var iconLock = "courses-movie-group-module--icon-lock--pCsXC";
export var notBoughtButtons = "courses-movie-group-module--not-bought-buttons--d8Znq";
export var pointsButtonWrapper = "courses-movie-group-module--points-button-wrapper--aK-ej";
export var ratioClass = "courses-movie-group-module--ratio-class--zzOgr";
export var video = "courses-movie-group-module--video--iATLP";
export var wrapper = "courses-movie-group-module--wrapper--FHUzE";